import React,{useEffect} from "react";
import "react-sortable-tree/style.css";
import { DndProvider } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";
import Split from "react-split";
import { BrowserRouter as Router, Switch, Route, Link } from "react-router-dom";

import GlobalState from "./useGlobalState";
import TopPanel from "./components/top-panel/TopPanel";
import ConfigPanel from "./components/config-panel/ConfigPanel";

import Preview from "./pages/preview/Preview";
import "./App.css";

function Editor() {

  const { state } = GlobalState.useContainer();
  useEffect(() => {
    localStorage.setItem("preview", JSON.stringify(state));
  }, [state]);
  return (
    <DndProvider backend={HTML5Backend}>
      <div className="h-screen">
        <Split
          sizes={[60, 40]}
          // minSize={100}
          // expandToMin={false}
          // gutterSize={10}
          // gutterAlign="center"
          // snapOffset={30}
          // dragInterval={1}
          direction="vertical"
          cursor="row-resize"
          className="flex flex-col justify-between h-full"
        >
          <TopPanel />

          <ConfigPanel />
        </Split>
      </div>
    </DndProvider>
  );
}
function App() {
  return (
    <Router>
      <Switch>
        <Route path="/preview">
          <Preview />
        </Route>
        <Route path="/">
          <Editor />
        </Route>
      </Switch>
    </Router>
  );
}

export default App;
